import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    showLoadindicator: true,
    dataLoadError: null,
    cmsData: null,
    currentLevelIndex: null,
    currentQuizOptions: null,
    levelStatistics: [],
    playAudio: true,
    isLevelEnd: false,
    stationStartTimestamp: null,
    stationEndTimestamp: null,
    clickCount: 0,
    screenState: 'quiz',
    lastHttpAction: null,
    sendStatisticsSuccess: null,
    visitorId: null,
    lang: null,
  },
  actions,
  getters,
  mutations,
});